<template>
  <div>
    <pxkeji-rightHeader />

    <div class="pxkeji-right-box">
      <!-- <pxkeji-btn name="ceshi" type="primary" size="large" roles="设备新增,设备编辑"  icon="search"  />  -->

      <a-form class="ant-advanced-search-form">
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item label="证书年份">
              <a-date-picker mode="year" format="YYYY" :open="yearOpen"  v-model="where.keyword.year" placeholder="请选择年份" @openChange="openYear" @panelChange="panelYear" :allowClear="false"/>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="证书申请日期">
              <a-range-picker @change="onCertificateTimeChange" />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="选课时间">
              <a-range-picker @change="onCourseTimeChange" />
            </a-form-item>
          </a-col>
          <a-col :span="6">
              <a-form-item label="单位">
                  <a-input placeholder="请输入" v-model="where.keyword.company"/>
              </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item label="用户信息">
              <a-input placeholder="请输入用户名/姓名/身份证号/手机号" v-model="where.keyword.name" />
            </a-form-item>
          </a-col>
          <a-col :span="6">
              <a-form-item label="地区">
                <a-cascader
                        :options="areas"
                        placeholder="请选择所在地区"
                        @change="onAreachange"
                        change-on-select
                        :default-value="areaList"
                        :fieldNames="{ label: 'name', value: 'name', children: 'children' }"
                />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="用户组">
                <a-select
                        show-search
                        v-model="where.keyword.groupId"
                        :filter-option="filterOption"
                        allowClear
                        @change="groupChanged"
                >
                  <a-select-option
                          :value="info.id"
                          v-for="(info, index) in grouplist"
                          :key="index"
                  >{{info.name}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
                <a-form-item label="主管部门">
                    <a-select
                            show-search
                            v-model="where.keyword.administration"
                            :filter-option="filterOption"
                            allowClear
                            @change="administrationChanged"
                    >
                        <a-select-option
                                :value="info.itemName"
                                v-for="(info, index) in administrationList"
                                :key="index"
                        >{{info.itemName}}
                        </a-select-option>
                    </a-select>
                </a-form-item>
            </a-col>
          </a-row>
        <a-row :gutter="24">
             <a-col :span="6">
              <a-form-item label="考试">
                <a-select
                        show-search
                        v-model="where.keyword.exam_id"
                        mode="multiple"
                        :filter-option="filterOption"
                        allowClear
                        @change="examinationChanged"
                >
                  <a-select-option
                          :value="info.id"
                          v-for="(info, index) in examinationList"
                          :key="index"
                  >{{info.name}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="16" :style="{ textAlign: 'right' }">
              <a-button type="primary" @click="searchList" v-btnlimit="'学习档案-搜索'">搜索</a-button>
              <a-button :style="{ marginLeft: '8px' }" @click="clear">清空</a-button>
            </a-col>

        </a-row>
      </a-form>
    </div>

    <div class="pxkeji-right-box">
      <pxkeji-btn name="导出" @click="exportExcel" class="pxkeji_basic_btn" v-btnlimit="'学习档案-导出'"/>
      <a-table
              :columns="list.columns"
              rowKey="id"
              :pagination="list.pagination"
               :scroll="{ x: 3000}"
              @change="onChange"
              :dataSource="list.datas"
              :loading="isloading"
              :locale="{emptyText:'暂无数据'}"
      >
      <span slot="examination" slot-scope="examination">
        <a-tag v-if="examination==0" color="red">未考试</a-tag>
        <a-tag v-else-if="examination==1" color="red">进行中</a-tag>
        <a-tag v-else-if="examination==2" color="red">不合格</a-tag>
        <a-tag v-else-if="examination==3" color="green">合格</a-tag>
        <a-tag v-else color="red">未考试</a-tag>
      </span>
      <span slot="certificate1" slot-scope="certificate1">
        <a-tag v-if="certificate1==1" color="green">通过</a-tag>
        <a-tag v-else-if="certificate1==2 ||certificate1==9 ||certificate1==0 " color="red">未通过</a-tag>
        <a-tag v-else color="red">未申请</a-tag>
      </span>
      <span slot="certificate2" slot-scope="certificate2">
        <a-tag v-if="certificate2==1" color="green">通过</a-tag>
        <a-tag v-else-if="certificate2==2 ||certificate2==9 ||certificate2==0 " color="red">未通过</a-tag>
        <a-tag v-else color="red">未申请</a-tag>
      </span>
      </a-table>
      <div class="totalbox" style="float: left;">
        <div>
          <span>共有：{{list.pagination.total}}条数据</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  var that;
  const columns = [

    {
      dataIndex: "account",
      key: "account",
      align: "center",
      title: "账号",
      width: 140,
    },
    {
      dataIndex: "fullName",
      key: "fullName",
      align: "center",
      title: "姓名",
    },
    {
      dataIndex: "province",
      key: "province",
      align: "center",
      title: "省",
    },
    {
      dataIndex: "city",
      key: "city",
      align: "center",
      title: "市",
    },
    {
      dataIndex: "area",
      key: "area",
      align: "center",
      title: "区",
    },
    {
      dataIndex: "idCard",
      key: "idCard",
      align: "center",
      title: "身份证号",
      width: 200,
    },
  /*  {
      dataIndex: "telephone",
      key: "telephone",
      align: "center",
      title: "手机号",
      width: 140,
    },*/

    {
      dataIndex: "company",
      key: "company",
      align: "center",
      title: "单位名称"
    },
    {
      dataIndex: "groupNames",
      key: "groupNames",
      align: "center",
      title: "用户组"
    },
    {
      dataIndex: "nation",
      key: "nation",
      align: "center",
      title: "民族"
    },
    {
      dataIndex: "politic",
      key: "politic",
      align: "center",
      title: "政治面貌"
    },
    {
      dataIndex: "titleSet",
      key: "titleSet",
      align: "center",
      title: "职称系列"
    },
    {
      dataIndex: "title",
      key: "title",
      align: "center",
      title: "职称"
    },
    {
      dataIndex: "gainCreTime",
      key: "gainCreTime",
      align: "center",
      title: "资格时间"
    },
    {
      dataIndex: "appointmentTime",
      key: "appointmentTime",
      align: "center",
      title: "聘任时间"
    },
    {
      dataIndex: "state",
      key: "state",
      align: "center",
      title: "在岗状态"
    },
    {
      dataIndex: "age",
      key: "age",
      align: "center",
      title: "年龄"
    },
    {
      dataIndex: "ggk_count",
      key: "ggk_count",
      align: "center",
      title: "公需课学时"
    },
    {
      dataIndex:"zyk_count",
      key: "zyk_count",
      align: "center",
      title: "专业课学时",
    },
    {
      dataIndex:"hour_count",
      key: "hour_count",
      align: "center",
      title: "共学习学时",
    },
    {
      dataIndex:"examination",
      key: "examination",
      align: "center",
      title: "考试合格情况",
      scopedSlots: {customRender: "examination"}
    },
    {
      dataIndex:"certificate1",
      key: "certificate1",
      align: "center",
      title: "公需课证书",
      scopedSlots: {customRender: "certificate1"}
    },
    {
      dataIndex:"certificate2",
      key: "certificate2",
      align: "center",
      title: "专业课证书",
      scopedSlots: {customRender: "certificate2"}
    },
  ];

  export default {
    name: "userlist",
    data() {
      return {
        expand: false, //高级搜索
        list: {
          columns, //表头
          datas: [], //数据
          pagination: {
            //分页器
            showQuickJumper: true,
            hideOnSinglePage: true,
            total: 0,
            current: 1, //页码
            defaultPageSize: 10 //页容
          }
        },
        where: {
          //查询条件
          keyword: {
            year:"",
            certificateStartTime:"",
            certificateEntTime:"",
            courseStartTime:"",
            courseEntTime:"",
            exam_id:[],
            provience:"",
            area:"",
            city:"",
            groupId:"",
            administration:"",
            company: "",
          }
        },
        yearOpen:false,
        examinationList:[],
        grouplist:[],
        areas:[],
        areaList: [],
        administrationList:[],
        isloading: false,
      };
    },
    mounted: function() {
      this.$nextTick(function() {
        this.areas=this.$api.city.city;
        that = this;
        this.GetList();
        this.getgrouplist();
        this.getDictionaryItem(); 
        this.getExaminationList();
      });
    },
    methods: {
      openYear(status){
        if(status){
          this.yearOpen=true;
        }else{
          this.yearOpen=false;
        }
      },
      panelYear(value){
        var year=this.$moment(value).format('YYYY');
        this.where.keyword.year=year;
        this.yearOpen=false;
      },
      onCertificateTimeChange(date, dateString) {
        this.where.keyword.certificateStartTime=dateString[0];
        this.where.keyword.certificateEntTime=dateString[1];
      },
      onCourseTimeChange(date, dateString){
        this.where.keyword.courseStartTime=dateString[0];
        this.where.keyword.courseEntTime=dateString[1];
      },
      getExaminationList(){
        this.isloading = true;
        this.$api.examination
          .getDataAll()
          .then(res => {
            this.isloading = false;
            if (res.errorCode == this.$msg.responseCode.success) {
              this.examinationList = res.data;
            } else {
              this.error(res.errorMsg);
            }
          })
          .catch(() => {
            this.isloading = false;
            this.error();
          });
      },
      //考试
      examinationChanged(v){
        this.where.keyword.exam_id= v;
      },
      //下拉框搜索
      filterOption(input, option) {
       return (
          option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
        );
      },
      //获取用户组
      getgrouplist() {
        this.isloading = true;
        this.$api.usergroup
          .getAll()
          .then(res => {
            this.isloading = false;
            if (res.errorCode == this.$msg.responseCode.success) {
              this.grouplist = res.data;
            } else {
              this.error(res.errorMsg);
            }
          })
          .catch(() => {
            this.isloading = false;
            this.error();
          });
      },
      //地区选择
      onAreachange(v){
        if(v[0]){
            this.where.keyword.provience=v[0];
          }else{
            this.where.keyword.provience='';
          }
          if(v[1]){
            this.where.keyword.city=v[1];
          }else{
            this.where.keyword.city='';
          }
          if(v[2]){
            this.where.keyword.area=v[2];
          }else{
            this.where.keyword.area='';
          }
      },
      //用户组选择
      groupChanged(v){
        this.where.keyword.groupId=v;
      },
      //获取主管部门
      getDictionaryItem() {
          this.$api.dictionaryItem.tree(23).then((res) => {
            if (res.errorCode == this.$msg.responseCode.success) {
              this.administrationList = res.data;
            } else {
              this.error(res.errorMsg);
            }
          });

      },
      //主管部门赋值
       administrationChanged(v) {
          this.where.keyword.administration = v;
      },
      GetList() {
        //获取列表
        this.isloading = true;
        var params=this.where.keyword;
        params.pageSize=this.list.pagination.defaultPageSize;
        params.pageNow=this.list.pagination.current;
        this.$api.learningArchives
                .getDataPageList(params)
                .then(res => {
                  this.isloading = false;
                  if (res.errorCode == this.$msg.responseCode.success) {
                    this.list.datas = res.data.data;
                    this.list.pagination.total = Number(res.data.total);
                  } else {
                    this.$message.error(res.errorMsg);
                  }
                })
                .catch(() => {
                  this.isloading = false;
                });
      },
      //切换页面
      onChange(page) {
        //页面切换回调
        this.list.pagination.current = page.current;
        this.GetList();
      },
      //搜索
      searchList() {
        this.list.pagination.current = 1;
        this.GetList();
      },
      //清空搜索条件
      clear() {
        for (var info in this.where.keyword) {
          this.where.keyword[info] = "";
        }
      },
      //导出
      exportExcel() {
        window.location.href = this.$api.learningArchives.exportData(this.where.keyword);
      }
    }
  };
</script>

<style>
  .ant-advanced-search-form .ant-form-item {
    display: flex;
  }

  .ant-advanced-search-form .ant-form-item-control-wrapper {
    flex: 1;
  }

  #components-form-demo-advanced-search .ant-form {
    max-width: none;
  }

  #components-form-demo-advanced-search .search-result-list {
    margin-top: 16px;
    border: 1px dashed #e9e9e9;
    border-radius: 6px;
    background-color: #fafafa;
    min-height: 200px;
    text-align: center;
    padding-top: 80px;
  }

  .cang_sta {
    text-align: center;
  }

  .cang_sta img {
    width: 35px;
  }
</style>

